// components/Elements/AccordionItem.jsx

import React from 'react';
import { ChevronDown } from 'lucide-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useAccordion } from './Accordion';

export const AccordionItem = ({ title, caption, children, index }) => {
  const { openIndex, toggle } = useAccordion();
  const isOpen = openIndex === index;

  return (
    <div
      className={clsx(
        'rounded-2xl border border-white/10 backdrop-blur-md bg-white/5 dark:bg-white/10 transition-all',
        isOpen && 'shadow-inner'
      )}
    >
      <button
        className="w-full flex justify-between items-center p-4 text-left"
        onClick={() => toggle(index)}
      >
        <div>
          <div className="text-sm font-semibold text-white">{title}</div>
          {caption && <div className="text-xs text-white/50">{caption}</div>}
        </div>
        <ChevronDown
          className={clsx(
            'w-5 h-5 text-white/60 transition-transform',
            isOpen && 'rotate-180'
          )}
        />
      </button>

      {isOpen && (
        <div className="px-4 pb-4 pt-2 text-white/90 text-sm border-t border-white/10">
          {children}
        </div>
      )}
    </div>
  );
};

AccordionItem.propTypes = {
  title: PropTypes.node.isRequired,
  caption: PropTypes.string,
  children: PropTypes.node.isRequired,
  index: PropTypes.number,
};
